import React, { forwardRef, useId } from "react";
import PropTypes from "prop-types";
import { Inbox } from "lucide-react";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "../../shadcn/components/ui/empty";
import { cn } from "../../shadcn/lib/utils";

// Adapted from the @shadcndesign empty-section-1 block: dashed panel, icon
// tile, title, description and actions.
const EmptyState = forwardRef(function EmptyState(
  { title, description, action, icon: Icon = Inbox, compact = false, className },
  ref
) {
  const titleId = useId();

  return (
    <Empty
      ref={ref}
      role="region"
      aria-labelledby={titleId}
      className={cn(
        "rounded-lg border border-dashed",
        compact ? "gap-3 p-4" : "gap-6 p-6",
        className
      )}
    >
      <EmptyHeader className="max-w-[640px]">
        <EmptyMedia className="size-12 rounded-md border bg-card p-2 shadow-sm">
          <Icon aria-hidden="true" className="size-6 text-foreground" />
        </EmptyMedia>
        <EmptyTitle
          id={titleId}
          role="heading"
          aria-level={2}
          className={compact ? "text-base" : undefined}
        >
          {title}
        </EmptyTitle>
        {description ? <EmptyDescription>{description}</EmptyDescription> : null}
      </EmptyHeader>
      {action ? (
        <EmptyContent className="md:flex-row md:justify-center">
          {action}
        </EmptyContent>
      ) : null}
    </Empty>
  );
});

EmptyState.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  action: PropTypes.node,
  icon: PropTypes.elementType,
  compact: PropTypes.bool,
  className: PropTypes.string,
};

export default EmptyState;
